import merge from "lodash/merge";
import api from "./api";
import config from "../config";
import UserStore from "../stores/UserStore";

function serializeOrder(order) {
  return {
    type: order.type || undefined,
    subitems: order.subitems,
    payment_token: order.payment_token,
    payment_intent: order.payment_intent,
    person: order.person ? order.person.id : undefined,
    coupon: order.coupon_id || order.coupon_code || undefined,
    pass: order.pass ? order.pass.id : undefined,
    event_bucket: order.event_bucket,
    email:
      order.group_sale_data && order.group_sale_data.length
        ? undefined
        : order.email,
    group_sale_data:
      order.group_sale_data && order.group_sale_data.length
        ? order.group_sale_data
        : undefined,
    name: order.name,
    mailing_address: order.mailing_address,
    phone_number: order.phone_number,
    additional_message: order.additional_message,
    check_number: order.check_number,
    payment_type: order.paymentType === "saved" ? "card" : order.paymentType,
    mark_as_used: order.mark_as_used,
    cart_id: order.cart_id,
    suppress_email_confirmation: order.suppress_email_confirmation
  };
}

export default {
  fetchStripeTerminalToken() {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `_scanner/terminal_connection_token?root=true`,
          api_key: UserStore.getState().apiKey
        },
        function (err, resp) {
          if (err) {
            return reject(err);
          }
          resolve(resp.secret);
        }
      );
    });
  },

  prepareOrder(apiKey, orderData) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `orders/prepare`,
          json: Object.assign(serializeOrder(orderData), {
            type: "box_office"
          }),
          api_key: UserStore.getState().apiKey
        },
        function (err, resp) {
          if (err) {
            return reject(err);
          }
          resolve(resp);
        }
      );
    });
  },

  submitOrder(apiKey, orderData) {
    let order = Object.assign({}, orderData);

    return new Promise((resolve, reject) => {
      if (order.paymentType === "card") {
        Stripe.card.createToken(
          order.paymentCardDetails,
          (status, response) => {
            if (response.error) {
              return reject(response.error);
            } else {
              delete order.paymentCardDetails;
              order.payment_token = response.id;
              continueSubmit();
            }
          }
        );
      } else {
        continueSubmit();
      }

      function continueSubmit() {
        api.request(
          {
            method: "POST",
            endpoint: `box_office/new_order`,
            json: serializeOrder(order),
            api_key: apiKey
          },
          function (err, response) {
            if (err) {
              return reject(err);
            }
            resolve(response);
          }
        );
      }
    });
  },

  testCoupon(apiKey, order) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `coupons/test`,
          json: {
            event_bucket: order.event_bucket,
            coupon_id: order.coupon_id,
            coupon_code: order.coupon_code,
            person: order.person ? order.person.id : undefined,
            order: JSON.stringify(order)
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return resolve({
              is_applicable: false,
              error: err.message || err
            });
          }

          resolve(response);
        }
      );
    });
  },

  testPass(apiKey, order) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `passes/test`,
          json: {
            event_bucket: order.event_bucket,
            pass: order.pass.id,
            order: JSON.stringify(order)
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return resolve({
              is_applicable: false,
              error: err.message || err
            });
          }

          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/BoxOfficeUtil.js